import DialogConfirmar, { DialogConfirmarProps } from './DialogConfirmar'

/**
 * Confirmação de exclusão: o `DialogConfirmar` com o botão vermelho "Excluir".
 * Os dois padrões continuam sobrescrevíveis — a exclusão de ocorrências alterna
 * o rótulo entre "Excluir" e "Desativar".
 */
export default function ConfirmarExclusao({
    confirmar = 'Excluir',
    color = 'error',
    ...props
}: DialogConfirmarProps) {
    return <DialogConfirmar {...props} confirmar={confirmar} color={color} />
}
